import $axios from '../services/api.js'

const state = () => ({
    surahs: [],
    page: 0,
    next_page_url : null,
    loading: false,
    show_per_ayat: [],
    show_per_kata: [],
    show_per_kata_ayat: []
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.surahs = payload
    },

    SET_LOADING(state, payload) {
        state.loading = payload
    },

    ASSIGN_DATA_LOAD_MORE(state, payload) {
        state.surahs = state.surahs.concat(payload)
    },

    SET_PAGE(state, payload) {
        state.page = payload
    },

    SET_NEXT_PAGE(state, payload) {
        state.next_page_url = payload
    },
    SET_SHOW_PER_AYAT(state, payload) {
        state.show_per_ayat = payload
    },
    SET_SHOW_PER_KATA(state, payload) {
        state.show_per_kata = payload
    },
    SET_SHOW_PER_KATA_AYAT(state, payload) {
        state.show_per_kata_ayat = payload
    }
}

const actions = {
    getSurah({ commit }, payload) {
        commit("SET_LOADING", true)
        return new Promise((resolve) => {
            $axios.get(`api/quran`, {
                params: {
                    search: payload
                }
            })
            .then((response) => {
                    commit("SET_LOADING", false)
                    
                    commit('ASSIGN_DATA', response.data.data.data)

                    commit('SET_PAGE', response.data.data.current_page)
                    commit('SET_NEXT_PAGE', response.data.data.next_page_url)

                    resolve(response.data)
                })
        })
    },
    getSurahLoadMore({ commit }, payload) {
        return new Promise((resolve) => {
            $axios.get(`api/quran`, {
                params: {
                    page: payload
                }
            })
                .then((response) => {
                    commit('ASSIGN_DATA_LOAD_MORE', response.data.data.data)

                    commit('SET_PAGE', response.data.data.current_page)

                    commit('SET_NEXT_PAGE', response.data.data.next_page_url)

                    resolve(response.data)
                })
        })
    },
    getPerAyat({ commit }, payload) {
        return new Promise((resolve) => {
            $axios.get(`api/show-per-ayat`, {
                params: {
                    page: payload || 1
                }
            })
                .then((response) => {
                    commit('SET_SHOW_PER_AYAT', response.data.data);
                    resolve(response.data);
                });
        });
    },
    getPerKata({ commit }, payload) {
        return new Promise((resolve) => {
            $axios.get(`api/show-per-kata`, {
                params: {
                    page: payload || 1
                }
            })
                .then((response) => {
                    commit('SET_SHOW_PER_KATA', response.data.data);
                    resolve(response.data);
                });
        });
    },
    getPerKataAyat({ commit }, payload) {
        return new Promise((resolve) => {
            $axios.get(`api/show-per-kata-ayat`, {
                params: {
                    page: payload || 1
                }
            })
                .then((response) => {
                    commit('SET_SHOW_PER_KATA_AYAT', response.data.data);
                    resolve(response.data);
                });
        });
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}